import JobServiceClient from 'app/clients/jobService'
import axios from 'axios'

const API_URL = `${process.env.REACT_APP_JOBS_API_URL}`

export const fetchJobsById = (userId) => {
  return JobServiceClient.get(`/jobs/${userId}`)
}

export const fetchJobsByIdAndStatus = (userId, status, limit) => {
  return JobServiceClient.get(`/jobs/by-status/${userId}?status=${status}&limit=${limit}`)
}

export const fetchHomePageJobById = (jobId) => {
  return JobServiceClient.post(`/home/job/${jobId}`)
}

export const fetchHomeJobs = (params = {}) => {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, value)
    }
  })

  return JobServiceClient.get(`/home/jobs?${query.toString()}`)
}

export const createJobAPI = ({ userId, data }) => {
  return JobServiceClient.post(`/job/${userId}`, data)
}

export const updateJobAPI = ({ userId, data }) => {
  return JobServiceClient.put(`/job/${userId}`, data)
}

export const deactivateJobAPI = ({ jobId }) => {
  return JobServiceClient.get(`/job/deactivate/${jobId}`)
}

export const activateJobAPI = ({ jobId }) => {
  return JobServiceClient.get(`/job/activate/${jobId}`)
}

export const fetchJobsByFilter = (params, signal) => {
  return JobServiceClient.post(`/search/jobs`, params, { signal })
}

export const fetchJobByID = ({ id, data }) => {
  return JobServiceClient.post(`${API_URL}/job/get/${id}`, data)
}

export const getStatusJobApplicantsForEmployer = (id) => {
  return JobServiceClient.get(`/jobs/${id}/get-candidates-number`)
}
